<template>
    <div class="project-image-item">
      <div class="image-container">
        <img :src="image.src" :alt="image.caption" class="project-detail-image">
      </div>
      <p v-if="image.caption" class="image-caption">{{ image.caption }}</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ProjectImage',
    props: {
      image: {
        type: Object,
        required: true
      }
    }
  }
  </script>
  
  <style scoped>
  .project-image-item {
    margin-bottom: 30px;
  }
  
  .image-container {
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
  
  .project-detail-image {
    width: 100%;
    display: block;
  }
  
  .image-caption {
    margin-top: 10px;
    text-align: center;
    font-style: italic;
    color: #e0e0e0;
    padding: 0 20px;
  }
  </style>